import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import ArrowBlackRight from "../../assets/arrow-right-black.svg";
import { sectionCard } from "../../compilers/sectionCard";
import { useTranslation } from "react-i18next";
import "../../stylesheet/components/sections/SectionCard.scss";

interface SectionCardProps {
  card: sectionCard;
  smallTitle?: boolean;
  image?: string;
  disabled?: boolean;
  lang?: string;
}

const SectionCard: React.FC<SectionCardProps> = ({
  card,
  smallTitle,
  image,
  disabled,
  lang,
}) => {
  const icon = useRef<HTMLImageElement>(null);
  const arrow = useRef<HTMLDivElement>(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    switch (lang) {
      case "ar":
        // Handling icon
        if (icon.current) {
          icon.current.classList.toggle("rtl");
        }
        if (arrow.current) {
          arrow.current.style.transform = "rotate(180deg)";
        }
        break;
      default:
        break;
    }
  }, []);

  const getImage = () => {
    if (image) {
      return (
        <img
          ref={icon}
          className="card__inner-illustration"
          src={image}
          alt="card icon"
        />
      );
    }
    // else {
    // 	return (
    // 		<img
    // 			ref={icon}
    // 			className="card__inner-logo"
    // 			src="/img/icon/bitcoin-icon.png"
    // 			alt="Bitcoin icon"
    // 		/>
    // 	);
    // }
  };
  //console.log(lang);
  {
    `/${i18n.language}/academy/catalogue`;
  }

  return (
    // <div className="col-xl-4 col-lg-6 col-md-6 align-self-stretch">
    <div className="section-card">
      <Link
        className={`card category shadow-sm border-0 p-3 h-100 justify-content-between ${
          disabled ? "disabled" : ""
        }`}
        to={`${disabled ? "#" : "/" + i18n.language + "/" + card.link}`}
      >
        {getImage()}
        <div className="card-inner-content d-flex">
          <div className="card-inner-info">
            {smallTitle ? <h5>{card.title}</h5> : <h3>{card.title}</h3>}
            <p className="p2">{card.body}</p>
          </div>
        </div>
        {!disabled ? (
          <div ref={arrow} className="link-arrow-outer">
            <img src={ArrowBlackRight} alt="arrow-black-right" />
          </div>
        ) : lang == "en" ? (
          <p
            className="coming-soon"
            style={{ fontSize: "small", textAlign: "right" }}
          >
            Coming soon...
          </p>
        ) : (
          <p
            className="coming-soon"
            style={{ fontSize: "small", textAlign: "left" }}
          >
            قريباً
          </p>
        )}
      </Link>
    </div>
  );
};

export default SectionCard;
